import React, { useState } from 'react'
import TooltipText from '../../../components/Tooltip';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'

const getClassName = (name) => {
    switch (name) {
        case 'Available':
            return 'bg-green100 border !border-green';
        case 'Booked':
            return 'bg-blueHighlight border !border-primary';
        case 'Unavailable':
            return 'border border-grayLight bg-grayLight';
        case 'Blocked':
            return 'border border-primary relative inventory-box';
    }
}

const getStatusClass = (status) => {
    switch (status) {
        case 'Available':
            return 'text-green bg-green100'
        case 'Unavailable':
            return 'text-black700 bg-black200'
        case 'Blocked':
            return 'text-primary bg-blueHighlight'
        case 'Pending confirmation':
            return 'text-primary bg-blueHighlight'
        case 'Booked':
            return 'text-white bg-primary'
    }
}

const newUnitList = [
    {
        "floor_no": 1,
        "block_id": 101,
        "units": [
            {
                "uuid": "unit-001",
                "name": "Unit A",
                "floor_no": 1,
                "facing": "North",
                "base_price": 500000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 10000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 15000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 20000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 25000,
                "bathroom_count": 2,
                "furnishing": "Semi-Furnished",
                "status": "Available",
                "car_parking": 1,
                "plan_link": "http://example.com/planA",
                "personal_washroom": true,
                "seats_count": 4,
                "office_cabins": 2,
                "booking_stage": "Initial",
                "configuration": {
                    "id": 1,
                    "unit_type": "Flat",
                    "uuid": "config-001",
                    "unit_configuration": "3 BHK",
                    "configuration_title": "Luxury 3 BHK",
                    "carpet_area": 1200,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1500,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1300,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.5,
                    "plot_area_unit": "acres",
                    "parking_slot": 1,
                    "price": 500000
                },
                "block": "Block A"
            },
            {
                "uuid": "unit-002",
                "name": "Unit B",
                "floor_no": 1,
                "facing": "South",
                "base_price": 550000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 12000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 16000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 21000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 26000,
                "bathroom_count": 2,
                "furnishing": "Fully-Furnished",
                "status": "Booked",
                "car_parking": 1,
                "plan_link": "http://example.com/planB",
                "personal_washroom": true,
                "seats_count": 5,
                "office_cabins": 3,
                "booking_stage": "Final",
                "configuration": {
                    "id": 2,
                    "unit_type": "Flat",
                    "uuid": "config-002",
                    "unit_configuration": "4 BHK",
                    "configuration_title": "Luxury 4 BHK",
                    "carpet_area": 1400,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1700,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1500,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.6,
                    "plot_area_unit": "acres",
                    "parking_slot": 2,
                    "price": 550000
                },
                "block": "Block A"
            },
            {
                "uuid": "unit-113",
                "name": "Unit A1",
                "floor_no": 1,
                "facing": "North",
                "base_price": 500000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 10000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 15000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 20000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 25000,
                "bathroom_count": 2,
                "furnishing": "Semi-Furnished",
                "status": "Available",
                "car_parking": 1,
                "plan_link": "http://example.com/planA",
                "personal_washroom": true,
                "seats_count": 4,
                "office_cabins": 2,
                "booking_stage": "Initial",
                "configuration": {
                    "id": 1,
                    "unit_type": "Flat",
                    "uuid": "config-001",
                    "unit_configuration": "3 BHK",
                    "configuration_title": "Luxury 3 BHK",
                    "carpet_area": 1200,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1500,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1300,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.5,
                    "plot_area_unit": "acres",
                    "parking_slot": 1,
                    "price": 500000
                },
                "block": "Block A"
            },
            {
                "uuid": "unit-112",
                "name": "Unit A2",
                "floor_no": 1,
                "facing": "North",
                "base_price": 500000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 10000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 15000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 20000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 25000,
                "bathroom_count": 2,
                "furnishing": "Semi-Furnished",
                "status": "Available",
                "car_parking": 1,
                "plan_link": "http://example.com/planA",
                "personal_washroom": true,
                "seats_count": 4,
                "office_cabins": 2,
                "booking_stage": "Initial",
                "configuration": {
                    "id": 1,
                    "unit_type": "Flat",
                    "uuid": "config-001",
                    "unit_configuration": "3 BHK",
                    "configuration_title": "Luxury 3 BHK",
                    "carpet_area": 1200,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1500,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1300,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.5,
                    "plot_area_unit": "acres",
                    "parking_slot": 1,
                    "price": 500000
                },
                "block": "Block A"
            },
            {
                "uuid": "unit-113",
                "name": "Unit A3",
                "floor_no": 1,
                "facing": "North",
                "base_price": 500000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 10000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 15000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 20000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 25000,
                "bathroom_count": 2,
                "furnishing": "Semi-Furnished",
                "status": "Available",
                "car_parking": 1,
                "plan_link": "http://example.com/planA",
                "personal_washroom": true,
                "seats_count": 4,
                "office_cabins": 2,
                "booking_stage": "Initial",
                "configuration": {
                    "id": 1,
                    "unit_type": "Flat",
                    "uuid": "config-001",
                    "unit_configuration": "3 BHK",
                    "configuration_title": "Luxury 3 BHK",
                    "carpet_area": 1200,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1500,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1300,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.5,
                    "plot_area_unit": "acres",
                    "parking_slot": 1,
                    "price": 500000
                },
                "block": "Block A"
            },
        ]
    },
    {
        "floor_no": 2,
        "block_id": 102,
        "units": [
            {
                "uuid": "unit-003",
                "name": "Unit C",
                "floor_no": 2,
                "facing": "East",
                "base_price": 600000,
                "plc_charge1_type": "Type1",
                "plc_charge1": 13000,
                "plc_charge2_type": "Type2",
                "plc_charge2": 17000,
                "plc_charge3_type": "Type3",
                "plc_charge3": 22000,
                "plc_charge4_type": "Type4",
                "plc_charge4": 27000,
                "bathroom_count": 3,
                "furnishing": "Unfurnished",
                "status": "Available",
                "car_parking": 2,
                "plan_link": "http://example.com/planC",
                "personal_washroom": false,
                "seats_count": 6,
                "office_cabins": 4,
                "booking_stage": "Initial",
                "configuration": {
                    "id": 3,
                    "unit_type": "Flat",
                    "uuid": "config-003",
                    "unit_configuration": "5 BHK",
                    "configuration_title": "Luxury 5 BHK",
                    "carpet_area": 1600,
                    "carpet_area_unit": "Sq.feet",
                    "super_area": 1900,
                    "super_area_unit": "Sq.feet",
                    "built_up_area": 1700,
                    "built_up_area_unit": "Sq.feet",
                    "plot_area": 0.7,
                    "plot_area_unit": "acres",
                    "parking_slot": 2,
                    "price": 600000
                },
                "block": "Block B"
            }
        ]
    }
]

const GridView = ({
    unitList,
    isUnitTypePlot,
    getSelectedUnitBookings,
    inventoryStats,
    inventoryStatsCount,
    setSelectedStatus,
    selectedStatus,
    unitNameWiseCount,
    gridProjectUnits
}) => {
    const [selectedUnit, setSelectedUnit] = useState();

    const handleMouseEnter = (name, index) => {
        const el = document.getElementById(`${name}_${index}`);
        el.classList.remove('hidden');
        el.classList.add('inline-block');
        console.log(el.classList, 'classlist', `${name}_${index}`)
    }
    const handleMouseLeave = (name, index) => {
        const el = document.getElementById(`${name}_${index}`)
        el.classList.add('hidden');
        el.classList.remove('inline-block');
    }


    const handleSelectUnit = (floor) => {
        const selected = gridProjectUnits.find(list => list.floor_no === floor)
        setSelectedUnit(selected);
    }

    const getAreaUnit = (config) => {
        if (config?.carpet_area !== null) {
            return <>
                <span>{config.unit_configuration}</span>
                <span className='w-1 h-1 rounded-full bg-black700 mx-1'></span>
                <span>{config.carpet_area} {config.carpet_area_unit}</span>
            </>
        } else if (config?.super_area !== null) {
            return <>
                <span>{config.unit_configuration}</span>
                <span className='w-1 h-1 rounded-full bg-black700 mx-1'></span>
                <span>{config.super_area} {config.super_area_unit}</span>
            </>
        } else if (config?.built_up_area !== null) {
            return <>
                <span>{config.unit_configuration}</span>
                <span className='w-1 h-1 rounded-full bg-black700 mx-1'></span>
                <span>{config.built_up_area} {config.built_up_area_unit}</span>
            </>
        }
    }

    return (
        <div className='!p-5'>
            <div className='flex !gap-5'>
                <div className='max-h-[75vh]  overflow-y-auto overflow-x-hidden'>
                    {
                        gridProjectUnits.map((list, index) => (
                            <div key={`${index}`} className={`border-b border-dashed !pb-4`}>
                                <div
                                    className={`w-max h-max !p-4 border rounded-lg !mt-4 cursor-pointer flex flex-col justify-center ${selectedUnit?.floor_no === list.floor_no ? 'border-primary' : ''}`}
                                    onClick={() => handleSelectUnit(list.floor_no)}

                                >
                                    <div className='font-semibold text-black800 text-base'> Floor {list.floor_no}</div>
                                    <div className='text-black700 text-xs font-medium'>{list.units.length} units</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                {!selectedUnit && <div className='w-4/5 rounded-lg border !p-4 bg-black100  max-h-[75vh]  overflow-auto'>
                    {gridProjectUnits.map((list, index) => (
                        <div className=' overflow-auto whitespace-nowrap border-b border-dashed !pb-4 space-x-4 !mb-4' key={`${index}_${list.floor_no}`}>
                            {
                                list.units.length > 0 && list.units.map((unit, uIndex) => (
                                    <div className='w-[236px] inline-block h-max !p-4 rounded-lg bg-white shadow-md cursor-pointer'
                                        onClick={() => {
                                            getSelectedUnitBookings(unit.uuid, 'view', unit);
                                        }}
                                    >
                                        <div className='flex justify-between items-center'>
                                            <span className='font-bold text-[#344054]'>{unit.name || '-'}</span>
                                            {/* <div className='bg-green100 py-1.5 px-2.5 rounded-lg'>
                                        <span className='text-green text-xs'>Available</span>
                                    </div> */}
                                            <div className={`text-xs text-center rounded-lg p-1 capitalize ${getStatusClass(unit.status)}`}>
                                                {unit.status}{`${(unit.status === 'Pending confirmation' || unit.status === 'Blocked') ? ' (' + unit.booking_stage + ')' : ''}`}
                                            </div>
                                        </div>
                                        <div>
                                            <p className='m-0 flex text-xs font-medium text-black700 items-center'>
                                                {unit.configuration.unit_type === 'Plot' &&
                                                    <span>{unit.configuration.plot_area ? `${unit.configuration.plot_area} ${unit.configuration.plot_area_unit}` : '-'}</span>
                                                }
                                                {unit.configuration.unit_type !== 'Plot' && <>
                                                    {getAreaUnit(unit.configuration)}
                                                </>}
                                            </p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ))}
                    {/* {
                        unitList.map((unit, index) => (
                            <div className='w-[236px] h-max !p-4 rounded-lg bg-white shadow-md cursor-pointer'
                                onClick={() => {
                                    getSelectedUnitBookings(unit.uuid, 'view', unit);
                                }}
                            >
                                <div className='flex justify-between items-center'>
                                    <span className='font-bold text-[#344054]'>{unit.name || '-'}</span>
                                    {/* <div className='bg-green100 py-1.5 px-2.5 rounded-lg'>
                                        <span className='text-green text-xs'>Available</span>
                                    </div>
                                    <div className={`text-xs text-center rounded-lg p-1 capitalize ${getStatusClass(unit.status)}`}>
                                        {unit.status}{`${(unit.status === 'Pending confirmation' || unit.status === 'Blocked') ? ' (' + unit.booking_stage + ')' : ''}`}
                                    </div>
                                </div>
                                <div>
                                    <p className='m-0 flex text-xs font-medium text-black700 items-center'>
                                        {unit.configuration.unit_type === 'Plot' &&
                                            <span>{unit.configuration.plot_area ? `${unit.configuration.plot_area} ${unit.configuration.plot_area_unit}` : '-'}</span>
                                        }
                                        {unit.configuration.unit_type !== 'Plot' && <>
                                            {getAreaUnit(unit.configuration)}
                                        </>}
                                    </p>
                                </div>
                            </div>
                        ))
                    } */}
                </div>}
                {selectedUnit && <div className='w-4/5 flex justify-between  rounded-lg border border-primary !p-4 bg-black100  max-h-[70vh]  overflow-auto'>
                    <div className='w-9/12 grid grid-cols-3 !gap-4'>
                        {selectedUnit.units.map((unit, uIndex) => (
                            <div className='w-[236px] inline-block h-max !p-4 rounded-lg bg-white shadow-md cursor-pointer'
                                onClick={() => {
                                    getSelectedUnitBookings(unit.uuid, 'view', unit);
                                }}
                                key={`${uIndex}_${unit.uuid}`}
                            >
                                <div className='flex justify-between items-center'>
                                    <span className='font-bold text-[#344054]'>{unit.name || '-'}</span>
                                    {/* <div className='bg-green100 py-1.5 px-2.5 rounded-lg'>
                                        <span className='text-green text-xs'>Available</span>
                                    </div> */}
                                    <div className={`text-xs text-center rounded-lg p-1 capitalize ${getStatusClass(unit.status)}`}>
                                        {unit.status}{`${(unit.status === 'Pending confirmation' || unit.status === 'Blocked') ? ' (' + unit.booking_stage + ')' : ''}`}
                                    </div>
                                </div>
                                <div>
                                    <p className='m-0 flex text-xs font-medium text-black700 items-center'>
                                        {unit.configuration.unit_type === 'Plot' &&
                                            <span>{unit.configuration.plot_area ? `${unit.configuration.plot_area} ${unit.configuration.plot_area_unit}` : '-'}</span>
                                        }
                                        {unit.configuration.unit_type !== 'Plot' && <>
                                            {getAreaUnit(unit.configuration)}
                                        </>}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='border flex rounded-lg h-max cursor-pointer font-medium text-sm items-center !p-2 bg-white' onClick={() => setSelectedUnit()}>
                        Clear Selection
                        <CloseIcon className='h-3 w-3 !ml-2' />
                    </div>
                </div>}
                <div className='w-[137px] h-max border rounded-lg p-2.5 space-y-3.5'>
                    {
                        inventoryStats.map((stat, index) => (
                            <div className={`flex items-center justify-between text-[10px] ${selectedStatus === stat.display_name ? 'text-textblack' : 'text-black700'} font-medium`}>
                                <div className='flex items-center cursor-pointer'
                                    onClick={() => setSelectedStatus(stat.display_name)}
                                // onMouseOver={() => handleMouseEnter(stat.display_name, index)}
                                // onMouseLeave={() => handleMouseLeave(stat.display_name, index)}
                                >
                                    <div className={`w-6 h-6 rounded-lg mr-1.5 ${getClassName(stat.display_name)}`}></div>
                                    <p className='m-0' id={`${stat.display_name}_${index}`}>{stat.display_name}</p>
                                </div>
                                <p className='m-0'>{inventoryStatsCount[stat.display_name] || '-'}</p>
                            </div>
                        ))
                    }

                    {/* <div className='flex items-center justify-between text-[10px] text-textblack font-bold'>
                        <div className='flex items-center '>
                            <div className='w-6 h-6 rounded-lg bg-primary border-primary border mr-1.5'></div>
                            <p className='m-0'>Booked</p>
                        </div>
                        <p className='m-0'>84</p>
                    </div>
                    <div className='flex items-center justify-between text-[10px] text-textblack font-bold'>
                        <div className='flex items-center '>
                            <div className='w-6 h-6 rounded-lg border-grayLight bg-grayLight border mr-1.5'></div>
                            <p className='m-0'>Unavailable</p>
                        </div>
                        <p className='m-0'>84</p>
                    </div>
                    <div className='flex items-center justify-between text-[10px] text-textblack font-bold'>
                        <div className='flex items-center '>
                            <div className='w-6 h-6 rounded-lg border border-primary mr-1.5 relative inventory-box'>                                
                </div>
                <p className='m-0'>Blocked</p>
            </div>
            <p className='m-0'>84</p>
        </div> * /}
                    {/* <div className='flex items-center justify-between text-[10px] text-textblack font-bold'>
                        <div className='flex items-center '>
                            <div className='w-6 h-6 rounded-lg border mr-1.5'></div>
                            <p className='m-0'>Details</p>
                        </div>
                    </div>
                    <div className='flex items-center justify-between text-[10px] text-textblack font-bold'>
                        <div className='flex items-center '>
                            <div className='w-6 h-6 rounded-lg border border-blueHighlight bg-blueHighlight mr-1.5'></div>
                            <p className='m-0'>Selected</p>
                        </div>
                    </div> */}
                </div >
            </div >
        </div >
    )
}

export default GridView